import { IMealCredit } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';
import { sdk } from 'src/utilities/sdk';

export interface FetchMealCreditDetailsProps {
  corpId: string;
  mealCreditId: string;
}

export const fetchMealCreditDetails = async ({
  corpId,
  mealCreditId,
}: FetchMealCreditDetailsProps): Promise<IMealCredit> => {
  return sdk.http.get(`/corps/${corpId}/eventmetadata/${mealCreditId}`);
};
